<script setup lang="ts">
/**
 * Section opener: optional eyebrow pill, heading, optional lead paragraph.
 * Centred by default (the template's "Section Block"); `align="left"` for the
 * heading-plus-button rows.
 */
withDefaults(defineProps<{
  title: string
  eyebrow?: string
  text?: string
  align?: 'center' | 'left'
  as?: 'h1' | 'h2' | 'h3'
  /** Tailwind max-width for the block. */
  width?: string
}>(), {
  align: 'center',
  as: 'h2',
  width: 'max-w-3xl',
})
</script>

<template>
  <div
    class="mb-10 md:mb-[3.75rem] lg:mb-20"
    :class="[width, align === 'center' ? 'mx-auto text-center' : 'text-left']"
  >
    <div v-if="eyebrow" class="eyebrow mb-5">{{ eyebrow }}</div>
    <component :is="as">{{ title }}</component>
    <p v-if="text" class="mt-5 text-lg md:text-xl">{{ text }}</p>
    <slot />
  </div>
</template>
